import { RouteConfig } from 'vue-router'

import isAuthenticatedGuard from '@/router/guards/isAuthenticated'

const BookingSuccessUnverified = () =>
  import('@/views/bookingFunnel/CSBookingSuccessUnverified.vue')

const BookingSuccess = () =>
  import('@/views/bookingFunnel/CSBookingSuccess.vue')

const emailVerificationRoutes: Array<RouteConfig> = [
  {
    path: '/erfolgreiche-buchung',
    name: 'erfolgreiche-buchung',
    meta: {
      gtm: 'booking funnel step 5 - success page',
      layout: 'booking-status',
      translateKey: 'PAGETITLE_GERMAN_SUCCESS_BOOKINGFUNNEL',
    },
    component: BookingSuccess,
    beforeEnter: isAuthenticatedGuard,
  },
  {
    path: '/erfolgreiche-buchung-unverifiziert',
    name: 'erfolgreiche-buchung-unverifiziert',
    component: BookingSuccessUnverified,
    meta: {
      layout: 'booking-status',
      gtm:
        'booking funnel step 5 - success page - email still needs to be confirmed',
      translateKey: 'PAGETITLE_GERMAN_SUCCESS_UNVERIFIED_BOOKINGFUNNEL',
    },
    beforeEnter: isAuthenticatedGuard,
  },
]

export default emailVerificationRoutes
